if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Free gift settings
        this.freeGiftVariantId = this.dataset.freeGiftVariantId;
        this.freeGiftMinQty = parseInt(this.dataset.freeGiftMinQty) || 1;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Check if free gift should be added
        const currentQty = parseInt(formData.get('quantity')) || 1;
        const shouldAddFreeGift = this.freeGiftVariantId && currentQty >= this.freeGiftMinQty;
        
        // Check if free gift element is active (visible)
        const freeGiftElement = document.querySelector('[data-free-gift]');
        const isFreeGiftActive = freeGiftElement && freeGiftElement.classList.contains('active');
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Function to add items to cart
        const addToCart = (items) => {
          const itemsConfig = fetchConfig('javascript');
          itemsConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          itemsConfig.headers['Content-Type'] = 'application/json';
          
          const body = { items: items };
          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }
          itemsConfig.body = JSON.stringify(body);
          
          return fetch(`${routes.cart_add_url}`, itemsConfig);
        };

        // If we need to add free gift, use the items endpoint
        if (shouldAddFreeGift && isFreeGiftActive) {
          const items = [
            {
              id: parseInt(formData.get('id')),
              quantity: currentQty
            },
            {
              id: parseInt(this.freeGiftVariantId),
              quantity: 1,
              properties: {
                '_free_gift': 'true',
                '_gift_for_product': formData.get('id')
              }
            }
          ];
          
          addToCart(items)
            .then((response) => response.json())
            .then((response) => {
              this.handleCartResponse(response, formData, evt);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.finalizeSubmit(evt);
            });
        } else {
          // Standard add to cart
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              this.handleCartResponse(response, formData, evt);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.finalizeSubmit(evt);
            });
        }
      }

      handleCartResponse(response, formData, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }
      }

      finalizeSubmit(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent("add:user-action", evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }

        this.variantUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function(data){
          if(data){
            const variantPrice = data.data.variant.price;
            if(variantPrice && document.querySelector('.buy-button_price')){
              document.querySelector('.buy-button_price').innerHTML = theme.Currency.formatMoney(variantPrice, window.shopSettings.moneyFormat);
            }
          }
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

const classesToCheck = [
    'product__media-wrapper',
    'product__text',
    'product-form__buttons',
    'icon-with-text'
];

function checkElementsVisibility() {
    const isAnyElementVisible = classesToCheck.some(className => {
        const elements = document.getElementsByClassName(className);
        return Array.from(elements).some(element => isElementInViewport(element));
    });

    const targetElements = document.querySelectorAll('.product-form__buttons_qty');
    
    targetElements.forEach(targetElement => {
        if (isAnyElementVisible) {
            targetElement.classList.remove('not-visible');
        } else {
            targetElement.classList.add('not-visible');
        }
    });
}

let ticking = false;

window.addEventListener('scroll', () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            checkElementsVisibility();
            ticking = false;
        });
        ticking = true;
    }
});

document.addEventListener('DOMContentLoaded', () => {
    checkElementsVisibility();
});

function refreshVisibilityCheck() {
    checkElementsVisibility();
}